import { ListItemIcon, ListItemText } from '../../../components/list';
import { Stack } from '../../../components/stack';

export type MenuLinkContentProps = {
  icon?: JSX.Element;
  title: string;
  titleStartIcon?: JSX.Element;
  titleEndIcon?: JSX.Element;
};

export const MenuLinkContent = ({
  icon,
  title,
  titleStartIcon,
  titleEndIcon,
}: MenuLinkContentProps) => (
  <>
    {icon && <ListItemIcon>{icon}</ListItemIcon>}
    <ListItemText>
      <Stack
        direction="row"
        spacing={1 / 2}
        sx={{
          alignItems: 'center',
          lineHeight: 'inherit',
        }}
      >
        {titleStartIcon}
        {title}
        {titleEndIcon}
      </Stack>
    </ListItemText>
  </>
);
